import { Col, Row } from 'react-bootstrap';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import IconWrapper from '../IconWrapper';
import { ICustomTableFooterProps } from './interfaces';
import './style.scss';

const CustomTableFooter = ({ pagination, onClick, loading }: ICustomTableFooterProps) => {
  const getPageRange = (): string => {
    const { page, pageSize, pageCount, totalCount } = pagination;
    if (pageCount === 0) return '0 - 0';
    const maxRange = page === pageCount ? totalCount : pageSize * page;
    const minRange = pageSize * (page - 1) + 1;

    return `${minRange} - ${maxRange}`;
  };

  const handleClick = (value: number) => {
    if (loading) return;

    const { page, pageCount } = pagination;
    let newValue = value;

    if (page === pageCount && value === 1) newValue = 0;
    if (page === 1 && value === -1) newValue = 0;

    onClick(newValue);
  };

  return (
    <Row className="table-footer mt-1 justify-content-space-between mx-2">
      <Col className="m-auto">
        {getPageRange()} de {pagination.totalCount}
      </Col>
      <Col className="footer-buttons" xs="auto">
        <div className="cursor-pointer" onClick={() => handleClick(-1)}>
          <IconWrapper size={25} color="text-black-50">
            <MdArrowBackIos />
          </IconWrapper>
        </div>
        <span>{pagination.page}</span>
        <div className="cursor-pointer" onClick={() => handleClick(1)}>
          <IconWrapper size={25} color="text-black-50">
            <MdArrowForwardIos />
          </IconWrapper>
        </div>
      </Col>
    </Row>
  );
};

export default CustomTableFooter;
